import { Modal, Box, IconButton, CloseIcon, PrivacyRadioGroup } from 'src/components';

export default function UserVisibilityModal({display, setDisplay}) {

    return (
        <Modal 
            open={display}
            onClose={() => setDisplay(false)}
            sx={{zIndex: 1000 }}>
                    <Box sx={{
                        bgcolor: '#fff',
                        width: '260px', 
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        padding: '15px',
                        paddingTop: '0px',
                        borderRadius: 2
                    }}>
                        <IconButton
                            onClick={() => setDisplay(false)}
                            size="small"
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 2
                            }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>

                        <PrivacyRadioGroup />

                    </Box>
        </Modal>
    );
}
